import {theme} from "./Tema";

export const GRADIENTE = 'linear-gradient(90deg, #8531FD 0%, #B996F9 100%)'

export const TIPODOCSREQ = ['Pdf', 'Imagen']

export const URLPAGINA = 'https://funnel.nebosystem.com/'

export const IDCORREOGLOBAL = 'global_gmail-com'

export const ESTADOSCAMPANAS = [
    {
        nombre: 'Iniciando',
        color: '#7A1CFF'
    },
    {
        nombre: 'Activo',
        color: '#00B8D9'
    },
    {
        nombre: 'Terminada',
        color: '#16A34A'
    },
    {
        nombre: 'Suspendida',
        color: '#EF4444'
    },
]

export const ESTADOSPRENDA = [
    {
        nombre: 'Pulicado',
        color: '#796254'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#5500d1'
    },
    {
        nombre: 'Admin',
        color: '#000000'
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]




export const TIPOSIMULACIONCONSULTOR = [
    {
        nombre: 'Venta Directa',
        color: '#5500d1'
    },
    {
        nombre: 'Venta de mi consultor',
        color: '#000000'
    },

]


export const TIPOSIMULACIONDISTRIBUIDOR = [
    {
        nombre: 'Venta Directa',
        color: '#5500d1'
    },
    {
        nombre: 'Venta de mi Hijo',
        color: '#000000'
    },
    {
        nombre: 'Venta de mi Nieto',
        color: '#000000'
    },

]


export const RANGOSCUENTA = ['Consultor', 'Distribuidor']

export const ESTADOSLEAD = [
    {
        nombre: 'Nuevo',
        color: '#5500d1'
    },
    {
        nombre: 'Contactado',
        color: '#0284C7'
    },
    {
        nombre: 'Convertido',
        color: '#22C55E'
    },

]


export const ESTADOSDEPOSITOS = [{
    nombre: 'Nuevo', color: '#7A1CFF'
}, {
    nombre: 'Enviado', color: '#0284C7'
}, {
    nombre: 'Aceptado', color: '#16A34A'
}, {
    nombre: 'Rechazado', color: '#DC2626'
}, {
    nombre: 'Archivado', color: '#6B7280'
},]

export const WALLETS =[
    {
        tipo: "USDT",
        nombre: 'TRC20',
        direccion: 'TWHSZH6icqvjJoLGPqDpxjvDv9ahK4LuTy'
    },
    {
        tipo: "USDT",
        nombre: 'BEP20',
        direccion: '0xa77c809Bd8e943C37b16327D1341AbcA60e793c6'
    },

]


